export interface StudyTask {
  id?: string;
  planId: string;
  userId?: string;
  name: string;
  type: TaskType;
  date: Date;
  duration: number; // Duration in minutes
  questionsCount?: number; // Number of questions for practice question tasks
  flashcardsCount?: number; // Number of flashcards for flashcard tasks
  completed: boolean;
  details: TaskDetails;
  createdAt: Date;
  updatedAt: Date;
  recurrence?: RecurrenceInfo; // Add recurrence information for recurring tasks
  isRecurringInstance?: boolean; // Indicates this is an instance of a recurring task
}

export interface RecurrenceInfo {
  endDate: Date;
  frequency: string;
  weekdays: string[];
  includeUnavailable: boolean;
}

export enum TaskType {
  PRACTICE_QUESTIONS = 'practiceQuestions',
  FLASHCARDS = 'flashcards',
  FOCUS_TIME = 'focusTime',
  COURSE_VIDEOS = 'courseVideos',
  CUSTOM = 'custom'
}

// Union type for all possible task details
export type TaskDetails = PracticeQuestionDetails | FlashcardDetails | FocusTimeDetails | CourseVideoDetails | CustomTaskDetails;

export interface PracticeQuestionDetails {
  questionModes: string[];
  subjectIds: string[];
  systemIds: string[];
  selectedCourse?: string;
  selectedQbanks?: string[];
  selectedSubjects?: string[];
  selectedSystems?: string[];
  selectedTopics?: string[];
  questionCount?: number;
  questionType?: string;  // The type of questions (unused, correct, etc.)
  statusLevel?: number;   // The numeric status level for the question type
  scheduling?: TaskSchedulingInfo; // Add scheduling info for easy reference
}

export interface TaskSchedulingInfo {
  startDate: Date;
  endDate?: Date;
  frequency?: string;
  weekdays?: string[];
  includeUnavailable?: boolean;
}

export enum QuestionMode {
  MARKED = 'marked',
  OMITTED = 'omitted',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  UNUSED = 'unused'
}

export interface FlashcardDetails {
  deckType: DeckType;
  deckIds: string[];
  scheduling?: TaskSchedulingInfo; // Add scheduling info for easy reference
}

export enum DeckType {
  READY_DECKS = 'readyDecks',
  MY_FLASHCARDS = 'myFlashcards'
}

export interface FocusTimeDetails {
  description?: string;
  scheduling?: TaskSchedulingInfo; // Add scheduling info for easy reference
}

export interface CourseVideoDetails {
  courseId: string;
  courseTitle: string;
  lessonId: string;
  lessonTitle: string;
  topicId?: string;
  topicTitle?: string;
  scheduling?: TaskSchedulingInfo;
}

export interface CustomTaskDetails {
  description?: string;
  scheduling?: TaskSchedulingInfo; // Add scheduling info for easy reference
} 